import jwt_decode from 'jwt-decode';



export default class DashUserToken {

    constructor(token) {
        this.setToken(token);
    }

    setToken(newToken) {
        if (!newToken) {
            throw new Error('DashUserToken: token param empty');
        }
        this.encodedToken = newToken;
        this.decodedToken = jwt_decode(newToken); // will throw on invalid token!
        this.userData = extractAuthStateFromTokenData(this.decodedToken);
    }

    // Totally untested. ;-) If you use this in the future, test it!
    callbackOnExpiration(cb) {
        var nowMs = Date.now();
        var expiresOnMs = new Date(this.userData.authExpiresOn).getTime();
        var diffMs = expiresOnMs - nowMs;
        var diffMinusTenSecMs = diffMs - (1000 * 10);
        if (diffMinusTenSecMs < 0) {
            throw new Error('Invalid expires in less than 10 seconds: ' + diffMs)
        }
        return setTimeout(cb, diffMinusTenSecMs);
    }
}


function extractAuthStateFromTokenData(jwToken) {

    // This would be a decoded token:
    // var decodedToken = {
    //     "email": "abby.admin@test.com",
    //     "sub": "abby.admin@test.com",
    //     "jti": "42d2fd33-81e1-4f2e-b36e-30039ac08e7b",
    //     "iat": 1471976848,
    //     "given_name": "Abby",
    //     "family_name": "Admin",
    //     ".issued": "Tue, 23 Aug 2016 18:27:28 GMT",
    //     ".expires": "Tue, 06 Sep 2016 18:27:28 GMT",
    //     "nameid": "7c956c8a-54a5-4b99-865a-713bd8c0785b",
    //     "unique_name": "abby.admin@test.com",
    //     "http://schemas.microsoft.com/accesscontrolservice/2010/07/claims/identityprovider": "ASP.NET Identity",
    //     "AspNet.Identity.SecurityStamp": "459f0126-f95b-4636-835e-dfc63d92bc43",
    //     "role": "Admin",
    //     "iss": "ParagonDashApi",
    //     "aud": "ParagonDashSpa",
    //     "exp": 1472063248,
    //     "nbf": 1471976848
    // }

    var authUserRoles = [].concat(jwToken.role);
    try {
        return {
            authUserEmail: jwToken.sub,
            authUserRoles: authUserRoles,
            authUserFirstName: jwToken.given_name,
            authUserLastName: jwToken.family_name,
            authIssuedOn: jwToken['.issued'],
            authExpiresOn: jwToken['.expires']
        };
    } catch (err) {
        return null;
    }
}

// function decodeJsonWebToken(encodedJwt) {
//     try {
//         return jwt_decode(encodedJwt);
//     } catch (err) {
//         return null;
//     }
// }



// WEBPACK FOOTER //
// ./src/DashAuthenticatedUser/DashUserToken.js


// WEBPACK FOOTER //
// webpack:///src/DashAuthenticatedUser/DashUserToken.js